import { createFileRoute } from '@tanstack/react-router'
import TarefaDetailPage from '@/pages/tarefas/tarefa-detail-page'

// Rota index para /dashboard/$dashboardId/atividades/$tarefaId
// Renderizada quando acessar diretamente /dashboard/$dashboardId/atividades/$tarefaId
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/atividades/$tarefaId/',
)({
  component: function TarefaDetailRoute() {
    const { dashboardId, tarefaId } = Route.useParams()
    return (
      <TarefaDetailPage tarefaId={tarefaId} dashboardId={dashboardId} />
    )
  },
})
